import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Image Plugins',
  basePath: '/itemserver-image-plugins',
  columns: [
    { key: 'article_section_name', label: 'Article Section', sortable: true },
    { key: 'plugin', label: 'Plugin', sortable: true,
      render: (v) => v === 'vip' ? 'Rectangle (VIP)' : String(v ?? '') },
    { key: 'required', label: 'Required', sortable: true,
      render: (v) => v == 1 ? 'Yes' : 'No' },
  ],
  fields: [
    { key: 'article_section', label: 'Article Section', type: 'async-select',
      optionsUrl: '/article-sections/options', required: true },
    { key: 'plugin', label: 'Photo Item Plugin', type: 'select',
      options: [
        { label: 'Square', value: 'square' },
        { label: 'Gallery', value: 'gallery' },
        { label: 'Rectangle (VIP)', value: 'vip' },
      ],
      required: true },
    { key: 'required', label: 'Required', type: 'yesno', defaultValue: '0' },
  ],
  defaultSort: { field: 'article_section_name', dir: 'asc' },
});
